// extracted by mini-css-extract-plugin
export default {"root":"tWuL7","text-block":"LDBrT","textBlock":"LDBrT","prefix":"_2JMas"};